import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'
import Tabs from '../components/Tabs/Tabs.js'

import { showTooltip, hideTooltip } from '../actions/actions.export.js';

var pf_config = require('../pf_config.json');

var compare_config = require('../compare_config.json');

class Compare extends Component {
  constructor(props){
    super(props);

    this.state = {
      top: true,
      team_size: 5
    }
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.document.title = "Compare - Pattycake";
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
    
    this.handleScroll();
  }
  
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  }

  handleScroll(event) {

    // var tableRect = this.compareTableDiv.getBoundingClientRect();
    
    // if(tableRect.y <= 0){
    //   var top = 0;
    //   if(this.state.show){
    //     var headerRect = this.fixedHeaderDiv.getBoundingClientRect();
    //     top = (tableRect.height - 48 - headerRect.height) + tableRect.y;
    //     if(top > 0) top = -2;
    //     // console.log(tableRect.y, top, top + tableRect.y);
    //   }
    //   this.setState({
    //     show: true,
    //     top: top,
    //     width: this.compareTableDiv.clientWidth
    //   });
    // } else {
    //   this.setState({
    //     show: false,
    //     top: 0,
    //     width: this.compareTableDiv.clientWidth
    //   });
    // }
  }

  render(){
    const { dispatch, user } = this.props;


    var compare = this.props.match.params.compare;
    var sorted_compare = [];
    var specific = false;

    // if(compare){
    //   compare = compare_config.info[compare];
    //   if(!compare) window.location = '/404';

    //   specific = true;
    //   sorted_compare = [compare];

    //   for(var i in compare_config.info){
    //     if(compare_config.info[i].display_name !== compare.display_name){
    //       sorted_compare.push(compare_config.info[i]);
    //     }
    //   }
    // } else {
    //   for(var i in compare_config.info){
    //     sorted_compare.push(compare_config.info[i]);
    //   }
    // }


    var features = [];
    var i;

    for(i in compare_config.features){
      features.push(compare_config.features[i]);
    }

    features.sort((a,b)=>{
      var ta = 0;
      for(i in a.availability){
        ta += a.availability[i] ? 1 : 0
      }
      var tb = 0;
      for(i in b.availability){
        tb += b.availability[i] ? 1 : 0
      }

      if(ta > tb) return -1;
      if(ta < tb) return 1;
      return 0;
    })

    var table_header = <thead>
      <tr>
        <th className="" style={{verticalAlign:'bottom'}}>
          <span className="text-700 text-gs1 availability-title">Capabilities</span><br/>
          <span className="text-muted">What can each do?</span>
        </th>


        {/* PATTYCAKE */}
        {
          this.state.team_size > 1 ?
          <th className={"th-availability " + (specific ? "th-availability-highlight-left" : "")}>
            <div className="availability-price">
              <div className="availability-price-number">
                <span className="dollar-sign">$</span>{(pf_config.plans.teams.price * (this.state.team_size) * 12).toLocaleString()}
              </div>
              <div className="availability-price-description">
                per year<br/>billed per month
              </div>
            </div>
            <div className="availability-title">{pf_config.plans.teams.display_name}</div>
            {
              user.isLoggedIn ?
              <Link to="/create-a-team">Create a Team <i className="fal fa-angle-right"/></Link>
              :
              <Link to="/sign-up?after=Y3JlYXRlLWEtdGVhbQ==">Create a Team <i className="fal fa-angle-right"/></Link>
            }
          </th>
          :
          <th className={"th-availability " + (specific ? "th-availability-highlight-left" : "")}>
            <div className="availability-price">
              <div className="availability-price-number">
                <span className="dollar-sign">$</span>{(pf_config.plans.pro.price * 12).toLocaleString()}
              </div>
              <div className="availability-price-description">
                per year<br/>billed per month
              </div>
            </div>
            <div className="availability-title">{pf_config.plans.pro.display_name}</div>
            {
              (user.isLoggedIn && user.roles.pro) &&
              <strong className="text-secondary"><i className="fas fa-check"/> Currently Pro</strong>
            }
            {
              (user.isLoggedIn && !user.roles.pro) &&
              <Link to="/my/settings/upgrade-to-pro">Upgrade to Pro <i className="fal fa-angle-right"/></Link>
            }
            {
              !user.isLoggedIn &&
              <Link to="/sign-up?after=bXkvZGFzaGJvYXJkL3VwZ3JhZGUtdG8tcHJv">Get Pro <i className="fal fa-angle-right"/></Link>
            }
          </th>
        }
        

        {
          sorted_compare.map((c, i)=>{
            return <th className={"th-availability " + ((i == 0 && specific) ? "th-availability-highlight-right" : "th-availability-not-highlighted")} key={i}>
              <div className="availability-price">
                <div className="availability-price-number">
                  <span className="dollar-sign">$</span>{(c.price_per_user * this.state.team_size).toLocaleString()}
                </div>
                <div className="availability-price-description">
                  versioned yearly<br/>fixed license{this.state.team_size > 1 && "s"}
                </div>
              </div>
              <div className="availability-title">{c.display_name}</div>
              <span>&nbsp;</span>
            </th>
          })
        }

      </tr>
    </thead>

    return <div className="landing">
      <div className="screen-height-container">
        <div className="shc-background translucent">
          
        </div>
        <div className="shc-content">
          <Header transparent={true}/>
          <div className="container">
            <div className="row row-padded">
              <div className="col-md-6">
                <h2>What makes Pattycake unique?</h2>
                <p className="lead">
                  Pattycake helps you create the pattern you need, <nobr>the moment you need it.</nobr>
                </p>
              </div>
            </div>
            <div className="row row-padded">

              <div className="col-md-4">
                <div className="col-themed">
                  <span class="fa-stack fa-lg fa-stack-fix-left-margin text-blue col-themed-icon">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-browser fa-stack-1x fa-inverse"></i>
                  </span>
                  <h3>No complicated installs</h3>
                  <p className="lead">
                    100% web-based, accessible from anywhere - even your phone. 
                  </p>
                  <Link to="/" className="col-themed-link">Learn more</Link>
                </div>
              </div>

              <div className="col-md-4">
                <div className="col-themed">
                  <span class="fa-stack fa-lg fa-stack-fix-left-margin text-green col-themed-icon">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-computer-classic fa-stack-1x fa-inverse"></i>
                  </span>
                  <h3>Always compatible</h3>
                  <p className="lead">
                    Whether you're using Revit 2020 or AutoCAD 2010 - Pattycake just works.
                  </p>
                  <Link to="/" className="col-themed-link">Learn more</Link>
                </div>
              </div>

              <div className="col-md-4">
                <div className="col-themed">
                  <span class="fa-stack fa-lg fa-stack-fix-left-margin text-orange col-themed-icon">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-box-full fa-stack-1x fa-inverse"></i>
                  </span>
                  <h3>Packed with features</h3>
                  <p className="lead">
                    Powerful text editor, integrated drawing, and algorithmic templates.
                  </p>
                  <Link to="/" className="col-themed-link">Learn more</Link>
                </div>
              </div>

              <div className="col-md-4">
                <div className="col-themed">
                  <span class="fa-stack fa-lg fa-stack-fix-left-margin text-pink col-themed-icon">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-hand-holding-usd fa-stack-1x fa-inverse"></i>
                  </span>
                  <h3>Pay monthly, cancel anytime</h3>
                  <p className="lead">
                    No long term commitments, licenses to upgrade, or versions to control.
                  </p>
                  <Link to="/" className="col-themed-link">Learn more</Link>
                </div>
              </div>


              <div className="col-md-4">
                <div className="col-themed">
                  <span class="fa-stack fa-lg fa-stack-fix-left-margin text-purple col-themed-icon">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-books fa-stack-1x fa-inverse"></i>
                  </span>
                  <h3>Free library of patterns</h3>
                  <p className="lead">
                    Always growing library of more than 400 materials in every format.
                  </p>
                  <Link to="/" className="col-themed-link">Learn more</Link>
                </div>
              </div>


              <div className="col-md-4">
                <div className="col-themed">
                  <span class="fa-stack fa-lg fa-stack-fix-left-margin text-danger col-themed-icon">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-comment-alt-smile fa-stack-1x fa-inverse"></i>
                  </span>
                  <h3>Helpful feedback</h3>
                  <p className="lead">
                    Built-in error detection for confusing and specific .PAT limitations
                  </p>
                  <Link to="/" className="col-themed-link">Learn more</Link>
                </div>
              </div>
            </div>
          {/*
            <div className="row justify-content-center row-mega-padded">
              <div className="col-md-6 text-center">
                <h2>Compare Pricing</h2>
                <p>
                  What size is your team?
                </p>
                <Tabs
                  items={[
                    {
                      display: 1,
                      value: 1
                    },
                    {
                      display: 5,
                      value: 5
                    },
                    {
                      display: 10,
                      value: 10
                    },
                    {
                      display: 50,
                      value: 50
                    }
                  ]}
                  value={this.state.team_size}
                  size='small'
                  onChange={(e) => { this.setState({ team_size: e.value }) }}
                />
              </div>
            </div>
            */}
          {/*
            <div className="row row-push-down">
              <div className="col-md-12">
                <div className="col-themed col-themed-shadow" style={{padding: 0}}>
                  <table className="table feature-table" ref={ (compareTableDiv) => this.compareTableDiv = compareTableDiv}>
                    { table_header }
                    <tbody>
                      {features.map((f, i)=>{
                        return <tr key={i}>
                          <td>
                            <div className="flex-split">
                              <strong>{f.display_name}</strong>
                            </div>
                          </td>
                          <td className="td-availability">{ f.availability.pattycake ? <i className="fas fa-lg fa-check-circle fa-fw text-success"/> : <i className="fal fa-lg fa-times fa-fw text-disabled"/>}</td>
                          {
                            sorted_compare.map((c,i)=>{
                              return <td className="td-availability">{ f.availability[c.key] ? <i className="fas fa-lg fa-check-circle fa-fw text-success"/> : <i className="fal fa-lg fa-times fa-fw text-disabled"/>}</td>
                            })
                          }
                        </tr>
                      })}
                    </tbody>
                  </table>
                 
                  {
                    this.state.show && 
                    <table className="table feature-table feature-table-fixed" style={{width: this.state.width, top: this.state.top}} ref={ (fixedHeaderDiv) => this.fixedHeaderDiv = fixedHeaderDiv}>
                      { table_header }
                    </table>
                  }
                </div>
                <div><small>
                  <p className="text-muted">
                    
                      The information on this page is for reference and educational purposes only. Pattycake makes no claim, warantee, or guarantee of the pricing nor functionality of another company's software. The pricing of another company's software may change at anytime and be out of date from what is listed currently on this site. For an exact comparison, visit their websites for more information.
                    
                  </p></small>
                </div>
              </div>
            </div>
            */}
          </div>
        </div>
      </div>
      <div className="section-breaker section-breaker-secondary">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="flex-center-column">
                <h3>Questions?</h3>
                <p className="text-center">Still wondering which plan is right for you? Have a great idea for a new feature? Reach out! We'd love to hear from you and will do our best to help.</p>
                <br/>
                <Link to="/contact" className="button-link">
                  <Button
                    display={<span>Get in touch&nbsp; <i className="fal fa-angle-right"/></span>}
                    color="white"
                    size="medium"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(Compare);




// WEBPACK FOOTER //
// ./src/routes/Compare.js